module.exports = __webpack_public_path__ + "img/potion_img_03.a509573e.png";